exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobileOnlyLogo{display:none !important}@media only screen and (max-width: 900px){.mobileOnlyLogo{display:block !important;position:fixed;left:20px;bottom:30px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/Menus/MainMenu/style.scss
// module id = 6205
// module chunks = 0